import {
  Target,
  PinkDumble,
  BorderTime,
  Paramid,
  ExerciseGaol,
  Fire,
} from "@utils/defaultImages";

export const getData = (data, t) => {
  if (!data) return [];

  return [
    {
      label: t("exercisePlan.duration"),
      key: "duration",
      icon: <BorderTime className="min-w-[16px] min-h-[16px]" />,
      tabColor: "#F1FFF0",
      value: data?.duration,
    },
    {
      label: t("exercisePlan.caloriesBurnt"),
      key: "calories",
      icon: <Fire className="min-w-[16px] min-h-[16px]" />,
      tabColor: "#FFF6F0",
      value: data?.calories,
    },
    {
      label: t("exercisePlan.Goal"),
      key: "goals",
      icon: <ExerciseGaol className="min-w-[16px] min-h-[16px]" />,
      tabColor: "#FFFFF0",
      value: data?.goals,
    },
    {
      label: t("exercisePlan.intensity"),
      key: "intensity",
      icon: <Paramid className="min-w-[16px] min-h-[16px]" />,
      tabColor: "#F0FFFF",
      value: data?.intensity,
    },
    {
      label: t("exercisePlan.workouts"),
      key: "workouts",
      icon: <PinkDumble className="min-w-[16px] min-h-[16px]" />,
      tabColor: "#FFF0FB",
      value:
        typeof data?.workouts === "number" || typeof data?.workouts === "string"
          ? data.workouts
          : "",
    },
    {
      label: t("exercisePlan.focus"),
      key: "focus",
      icon: <Target className="min-w-[16px] min-h-[16px]" />,
      tabColor: "#FFF0FF",
      value: data?.focus,
    },
  ];
};
